// src/library/api/userRoles.js
import axios from "axios";

const base = process.env.REACT_APP_BASE_SERVER;

// a tiny axios instance so we don't repeat configs
const http = axios.create({
    withCredentials: true,
});

const API = {
    clientUsersWithRoles: `${base}/client-users-with-roles`,
    assignUserRoles: `${base}/assign-user-roles`,
    clientValidationMethod: `${base}/client-validation-method`,
    addUsersToClient: `${base}/add-users-to-client`,
    removeUserFromClient: `${base}/remove-user-from-client`,
};

export async function fetchClientUsersWithRoles() {
    const res = await http.get(API.clientUsersWithRoles);
    return res.data;
}

export async function requestAssignUserRoles({ userUuid, roles }) {
    const res = await http.post(API.assignUserRoles, {
        userUuid,
        roles,
    });
    return res.data;
}

export async function requestUpdateClientValidationMethod({ validationMethod }) {
    const res = await http.post(API.clientValidationMethod, {
        validationMethod
    });
    return res.data;
}

export async function requestAddUsersToClient(req) {
    const res = await http.post(API.addUsersToClient, req);
    return res.data;
}

export async function requestRemoveUserFromClient({ clientId, userUuid }) {
    const res = await http.post(API.removeUserFromClient, { clientId, userUuid });
    return res.data;
}